<template>
  <div class="task-remind">
    <header class="top-wrap">
      <div class="main-title">任务提醒</div>
      <div class="right">
        <el-button type="primary" size="small" @click="showCreate">新建</el-button>
      </div>
    </header>
    <main class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="BaseTable"
        tableHeight="100%"
        :tableColumns="tableColumns"
        :tableData="filterData"
        :show-pagination="false"
      >
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" width="160">
            <template v-slot="scope">
              <el-button @click="showEditNotice(scope.row)" type="text" size="mini">
                编辑
              </el-button>
              <el-button @click="deleteTaskNotice(scope.row)" type="text" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
        </template>
      </BaseTable>
    </main>
    <base-dialog :visible.sync="noticeVisible" :show-close="true" v-loading="addLoading">
      <template v-slot:header>
        <div>新建任务提醒</div>
      </template>
      <el-form class="form" :model="curNotice" label-width="88px" label-position="left">
        <el-form-item prop="rule" label="提醒规则">
          <el-select v-model="curNotice.rule" placeholder="请选择" filterable @change="changeTime">
            <el-option
              v-for="item in ruleNames"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="timeFrame" label="时间节点">
          <el-input
            v-model="curNotice.timeFrame"
            type="number"
            :disabled="inputDisable"
            placeholder="请输入天数"
            style="width: 222px"
          >
            <span slot="suffix">天</span>
          </el-input>
        </el-form-item>
        <el-form-item prop="userType" label="提醒对象">
          <el-select v-model="curNotice.userType" multiple placeholder="请选择" filterable>
            <el-option
              v-for="item in userTypes"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="noticeType" label="提醒方式">
          <el-select v-model="curNotice.noticeType" multiple placeholder="请选择" filterable>
            <el-option
              v-for="item in noticeTypes"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button @click="noticeVisible = false">取消</base-button>
        <base-button type="primary" @click="createNotice">确定</base-button>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import * as taskApi from "@/api/project/task"
import BaseTable from "@/components/BaseComponents/Table"
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import { remindTableColumns as tableColumns } from "./static"

export default {
  name: "task-remind",
  components: { BaseTable, BaseDialog, BaseButton },
  data() {
    return {
      tableColumns,
      showTable: false,
      inputDisable: false,
      noticeVisible: false,
      addLoading: false,
      filterData: [],
      // pageInfo: {
      //   total: 1000,
      //   currentPage: 1,
      //   pageSize: 20
      // },
      searchText: "",
      ruleNames: [
        "任务创建时",
        "任务开始前",
        "任务开始时",
        "任务开始后",
        "任务截止前",
        "任务截止时",
        "任务截止后",
        "任务完成时"
      ],
      userTypes: ["负责人", "创建人", "参与人", "项目成员", "负责人汇报对象"],
      noticeTypes: ["网页", "钉钉", "钉钉群"],
      curNotice: {
        rule: "",
        timeFrame: 0,
        userType: [],
        noticeType: []
      },
      noticeList: []
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh: function() {
      this.showTable = false
      taskApi
        .getTaskNoticeList(this.$route.params.projectId)
        .then(noticeList => {
          for (var i = 0; i < noticeList.length; i++) {
            if (noticeList[i].timeFrame == 0) {
              noticeList[i].timeFrame = "当时"
            } else if (noticeList[i].timeFrame < 0) {
              noticeList[i].timeFrame = noticeList[i].timeFrame * -1 + "天"
            } else {
              noticeList[i].timeFrame = noticeList[i].timeFrame + "天"
            }
            noticeList[i].noticeType = noticeList[i].noticeType.join("， ")
            noticeList[i].userType = noticeList[i].userType.join("， ")
          }
          this.filterData = noticeList
          this.noticeList = noticeList
        })
        .finally(() => (this.showTable = true))
    },
    changeTime(obj) {
      if (obj == "任务开始时" || obj == "任务截止时" || obj == "任务完成时") {
        this.inputDisable = true
        this.curNotice.timeFrame = 0
      } else {
        this.inputDisable = false
      }
    },
    showCreate() {
      this.curNotice = {
        rule: "",
        timeFrame: 0,
        userType: [],
        noticeType: []
      }
      this.noticeVisible = true
    },
    showEditNotice(notice) {
      this.curNotice.id = notice.id
      this.curNotice.rule = notice.rule
      if (notice.timeFrame == "当时") {
        this.curNotice.timeFrame = 0
      } else {
        if (parseInt(notice.timeFrame.replace("天", "")) > 0) {
          this.curNotice.timeFrame = parseInt(notice.timeFrame.replace("天", ""))
        } else {
          this.curNotice.timeFrame = parseInt(notice.timeFrame.replace("天", "")) * -1
        }
      }
      this.curNotice.userType = notice.userType.split("， ")
      this.curNotice.noticeType = notice.noticeType.split("， ")
      this.noticeVisible = true
    },
    createNotice() {
      this.addLoading = true
      if (this.curNotice.id) {
        taskApi
          .updateTaskNotice(this.curNotice, this.curNotice.id)
          .then(res => {
            this.noticeVisible = false
            this.$message.success("编辑成功")
            this.refresh()
          })
          .finally(() => (this.addLoading = false))
      } else {
        if (this.curNotice.rule == "任务开始前" || this.curNotice.rule == "任务截止前") {
          this.curNotice.timeFrame = this.curNotice.timeFrame * -1
        }
        this.curNotice.projectId = this.$route.params.projectId
        taskApi
          .createTaskNotice(this.curNotice)
          .then(res => {
            this.noticeVisible = false
            this.$message.success("创建成功")
            this.refresh()
          })
          .finally(() => (this.addLoading = false))
      }
    },
    deleteTaskNotice(notice) {
      this.$confirm("确认删除该任务提醒？删除后将无法恢复！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          taskApi.deleteTaskNotice(notice.id).then(() => this.refresh())
        })
        .catch(() => {
          return
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.task-remind {
  .right ::v-deep {
    .el-input-group__append {
      padding: 0 10px;
    }
  }
  .main-wrap {
    height: calc(100% - 56px) !important;
  }
}
</style>
